module.exports = __webpack_public_path__ + "static/media/ratesIcon.f17d555e.svg";